var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _c(
            "q-toolbar-title",
            { staticClass: "q-body-2" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-grey-10 no-underline",
                  attrs: { to: { name: "time-tracking" } }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("time_tracking")) + "\n      "
                  )
                ]
              ),
              _vm._v(" / "),
              _c("span", { staticClass: "text-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("report")))
              ])
            ],
            1
          ),
          _c(
            "q-btn",
            {
              attrs: { icon: "save", flat: "", disable: !_vm.hasTimeEntries },
              on: { click: _vm.handleExportTimeReport }
            },
            [_c("q-tooltip", [_vm._v(_vm._s(_vm.$t("export_timereport")))])],
            1
          ),
          _c(
            "q-btn",
            { attrs: { flat: "" } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.dateRangeHumanReadable) + "\n      "
              ),
              _c("time-range-popover", {
                model: {
                  value: _vm.range,
                  callback: function($$v) {
                    _vm.range = $$v
                  },
                  expression: "range"
                }
              })
            ],
            1
          ),
          _c(
            "q-btn",
            {
              attrs: { label: _vm.$t("filter"), icon: "filter_list", flat: "" }
            },
            [
              _vm.filterCount > 0
                ? _c("q-chip", { attrs: { color: "primary", floating: "" } }, [
                    _vm._v(_vm._s(_vm.filterCount))
                  ])
                : _vm._e(),
              _c(
                "q-popover",
                [
                  _c(
                    "q-list",
                    { attrs: { separator: "", link: "" } },
                    [
                      _c(
                        "q-item",
                        [
                          _c("q-item-side", { attrs: { icon: "person" } }),
                          _c(
                            "q-item-main",
                            [
                              _c("q-select", {
                                attrs: {
                                  options: _vm.userIdFilterOptions,
                                  placeholder: _vm.$t(
                                    "time_tracking_filter_user_id"
                                  ),
                                  "hide-underline": "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.userId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "userId", $$v)
                                  },
                                  expression: "filter.userId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c("q-item-side", { attrs: { icon: "folder" } }),
                          _c(
                            "q-item-main",
                            [
                              _c("project-select", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "time_tracking_filter_project_id"
                                  ),
                                  "hide-underline": "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.projectId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "projectId", $$v)
                                  },
                                  expression: "filter.projectId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c("q-item-side", {
                            attrs: { icon: "attach_money" }
                          }),
                          _c(
                            "q-item-main",
                            [
                              _c("q-select", {
                                attrs: {
                                  options: _vm.billedFilterOptions,
                                  placeholder: _vm.$t(
                                    "time_tracking_filter_billed"
                                  ),
                                  "hide-underline": "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.billed,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "billed", $$v)
                                  },
                                  expression: "filter.billed"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c("q-item-side", { attrs: { icon: "contacts" } }),
                          _c(
                            "q-item-main",
                            [
                              _c("multi-customer-select", {
                                staticClass: "q-ma-none",
                                model: {
                                  value: _vm.filter.customer,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "customer", $$v)
                                  },
                                  expression: "filter.customer"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "layout-padding" },
        [
          _c("div", { staticClass: "row q-mb-lg" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-8" },
              [
                _vm.hasTimeEntries && _vm.timeEntriesStatistics
                  ? _c("time-entries-statistics-bar-chart", {
                      attrs: {
                        timeEntriesStatisticsData:
                          _vm.timeEntriesStatistics.value,
                        height: 250,
                        timeUnit: _vm.rangeUnit
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-4" },
              [
                _vm.hasTimeEntries && _vm.projectSecondsStatistics
                  ? _c("project-seconds-statistics-donut-chart", {
                      attrs: {
                        projectSecondsStatisticsData:
                          _vm.projectSecondsStatistics.value,
                        options: { legend: { position: "bottom" } },
                        height: 250
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "q-infinite-scroll",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasTimeEntries,
                  expression: "hasTimeEntries"
                }
              ],
              ref: "infiniteScroll",
              attrs: { handler: _vm.handleFetchNextChunk }
            },
            [
              _c("time-entries-list", {
                attrs: { "time-entries": _vm.timeEntries, showUser: true }
              })
            ],
            1
          ),
          !_vm.hasTimeEntries
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-center items-center col-grow q-mt-xl"
                  },
                  [
                    _c("div", { staticClass: "text-center" }, [
                      _c("img", {
                        attrs: {
                          src: require("assets/emptystates/time_entries_empty.svg")
                        }
                      }),
                      _c("h6", { staticClass: "q-my-md text-faded" }, [
                        _vm._v(_vm._s(_vm.$t("no_time_entries_found")))
                      ]),
                      _c("span", { staticClass: "text-faded" }, [
                        _vm._v(_vm._s(_vm.$t("change_filter_options")))
                      ])
                    ])
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }